<template>
    <!-- 我的钱包 -->
    <ZhaiHead />

    <div class="container-fluid px-0 zhu">
        <!-- 顶部核心数据模块（保持你原来的，不动） -->
        <div class="promo-top">
            <div class="promo-title">
                <div class="promo-left" @click="goBack">
                    <i class="fa fa-bullhorn"></i>推广中心
                </div>
                <div class="promo-center">我的钱包</div>
            </div>

            <div class="promo-main">
                <div class="promo-money">{{ todayIncome }}</div>
                <div class="promo-text">可用余额（元）</div>
            </div>
        </div>

        <!-- ✅ 红色板块下面所有元素：更贴近截图 -->
        <div class="wallet-body">

            <!-- 列表（铺满两侧，无圆角） -->
            <div class="wallet-list">
                <div class="wallet-item" @click="toBalanceDetail">
                    <div class="wallet-item-left">
                        <span class="wallet-ico">
                            <i class="fa fa-file-text-o"></i>
                        </span>
                        <span class="wallet-item-text">余额明细</span>
                    </div>
                    <i class="fa fa-angle-right wallet-arrow"></i>
                </div>

                <div class="wallet-item" @click="toWithdrawDetail">
                    <div class="wallet-item-left">
                        <span class="wallet-ico">
                            <i class="fa fa-th-large"></i>
                        </span>
                        <span class="wallet-item-text">提现明细</span>
                    </div>
                    <i class="fa fa-angle-right wallet-arrow"></i>
                </div>

                <div class="wallet-item" @click="toSetting">
                    <div class="wallet-item-left">
                        <span class="wallet-ico">
                            <i class="fa fa-cog"></i>
                        </span>
                        <span class="wallet-item-text">设置</span>
                    </div>
                    <i class="fa fa-angle-right wallet-arrow"></i>
                </div>
            </div>

            <!-- 按钮（跟截图风格一致） -->
            <div class="wallet-actions">
                <button class="wallet-btn wallet-btn-primary" @click="withdrawNow">
                    余额提现
                </button>

                <button class="wallet-btn wallet-btn-ghost" @click="goBack">
                    返回
                </button>
            </div>

        </div>
    </div>

    <ZhaiFoot />
</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";

    export default {
        name: "MMyWallet",
        components: { ZhaiHead, ZhaiFoot },

        data() {
            return {
                todayIncome: "0.00",
            };
        },

        methods: {
            goBack() {
                // 永远跳转到推广中心，不再返回上一页
                if (this.$router) {
                    this.$router.push("/Promotion");
                } else {
                    window.location.href = "/Promotion";
                }
            },
            // ✅ 下面几个跳转路径你按项目实际路由改一下
            toBalanceDetail() {
                if (this.$router) {
                    this.$router.push("/BalanceDetails");
                } else {
                    window.location.href = "/BalanceDetails";
                }
            },

            toWithdrawDetail() {
                if (this.$router) {
                    this.$router.push("/WithdrawalDetails");
                } else {
                    window.location.href = "/WithdrawalDetails";
                }
            },

            toSetting() {
                if (this.$router) {
                    this.$router.push("/WalletSettings");
                } else {
                    window.location.href = "/WalletSettings";
                }
            },

            withdrawNow() {
                if (this.$router) {
                    this.$router.push("/WalletWithdrawal");
                } else {
                    window.location.href = "/WalletWithdrawal";
                }
            }
        }
    };
</script>

<style scoped>
    /* ========== 顶部（保持你的结构，但我把“字体加粗”取消了） ========== */
    .fa {
        margin-right: 6px;
    }

    .zhu {
        margin-top: 80px;
    }

    /* 顶部模块 */
    .promo-top {
        background: #fff;
        border-top: 1px solid #dcdcdc;
        border-bottom: 1px solid #dcdcdc;
    }

    .promo-title {
        padding: 12px;
        font-weight: 400;
        border-bottom: 1px solid #e6e6e6;
        position: relative;
    }

    .promo-left {
        display: inline-block;
        font-weight: 400;
    }

    /* 中间标题 */
    .promo-center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-weight: 700;  /* ✅ 我的钱包加粗 */
        color: #00c853;
    }


    .promo-main {
        text-align: center;
        padding: 42px 12px;
        border-bottom: 1px solid #e6e6e6;
    }

    .promo-money {
        font-size: 44px;     /* ✅ 让数字更像截图（更大） */
        font-weight: 400;
        line-height: 1.1;
        color:#222;      /* 改回黑色 */         /* ⚠️如果你的顶部不是红色背景可删掉 */
    }

    .promo-text {
        margin-top: 8px;
        font-size: 14px;
        color:#666;      /* 改回灰色 */
        font-weight: 400;
    }

    /* ========== 红色板块下方（重点优化区域） ========== */
    .wallet-body {
        background: #f6f7fb;
        padding: 0 0 28px;
    }

    /* 列表铺满两侧，无圆角 */
    .wallet-list {
        background: #fff;
        width: 100%;
        margin: 0;
        border-radius: 0;
        overflow: hidden;
    }

    /* 每行更像原图：紧凑 + 高度适中 */
    .wallet-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 14px;
        border-bottom: 1px solid #f1f1f1;
    }

    .wallet-item:last-child {
        border-bottom: none;
    }

    .wallet-item-left {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .wallet-item-text {
        font-size: 16px;
        font-weight: 400;
        color: #222;
    }

    /* 右侧箭头更淡 */
    .wallet-arrow {
        font-size: 22px;
        color: #cfcfcf;
    }

    /* 左侧图标：更像截图（轻量图标 + 不抢戏） */
    .wallet-ico {
        width: 26px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        background: #fff;
    }

    .wallet-ico .fa {
        margin-right: 0;
        font-size: 18px;
        color: #ff4d4f; /* ✅ 红色图标更像截图 */
    }

    /* 按钮区：留白更像截图 */
    .wallet-actions {
        padding: 18px 14px 0;
    }

    /* 按钮 */
    .wallet-btn {
        width: 100%;
        border: none;
        height: 50px;              /* ✅ 更贴近截图按钮高度 */
        border-radius: 10px;
        font-size: 16px;
        font-weight: 400;
    }

    /* 主按钮：渐变红色 */
    .wallet-btn-primary {
        color: #fff;
        background: linear-gradient(90deg, #ff4d4f, #ff7a6a);
        box-shadow: 0 6px 16px rgba(255, 77, 79, 0.18);
    }

    /* 次按钮：更淡的底色 */
    .wallet-btn-ghost {
        margin-top: 14px;
        background: #fff0f0;
        color: #ff4d4f;
    }

    /* 点击反馈 */
    .wallet-item:active {
        background: #fafafa;
    }

    .wallet-btn:active {
        transform: scale(0.99);
    }
</style>